import React from 'react';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {ThemeProvider} from 'styled-components';
import {StylesProvider} from '@material-ui/styles';

import {AppTheme} from './app-theme';
import {BoilerplateGlobals} from './global-styles';

// Integrate styled-components and material-ui theme systems as per:
// @see https://material-ui.com/guides/interoperability/#theme
export const AppThemeProvider = ({ children, appTheme }: React.PropsWithChildren<{
    appTheme: AppTheme
}>) => {
    return (
        <StylesProvider injectFirst>
            <MuiThemeProvider theme={appTheme}>
                {/* @ts-ignore no need to type custom theme */}
                <ThemeProvider theme={appTheme}>
                    <>
                        <BoilerplateGlobals/>
                        {children}
                    </>
                </ThemeProvider>
            </MuiThemeProvider>
        </StylesProvider>
    );
};
